import type { Stage } from "@gw/shared-types";

// Stage-name label overrides matching the prototype (request-list.tsx lines 153-167).
const NAME_LABEL: Record<string, string> = {
  "Pre-Release": "Pre-release",
  "Request Completed to WO Submit": "Completed → submit",
  "WO Submit to Approve": "Submit → approve",
  "Request Processing": "Request processing",
};

interface Props {
  stage: Stage | null;
  unit?: "bd" | "cd";
}

export function BottleneckPill({ stage, unit = "bd" }: Props) {
  // Bottleneck is detected on business days; the displayed magnitude follows the active unit.
  const value = stage ? (unit === "cd" ? stage.cd : stage.bd) : 0;
  if (!stage || !stage.bd) {
    return <span style={{ color: "var(--fg-3)" }}>—</span>;
  }
  const label = NAME_LABEL[stage.name] ?? stage.name;
  const unitWord = unit === "cd" ? "calendar days" : "business days";
  return (
    <span
      className="bottleneck-pill"
      title={`${stage.name}: ${value.toFixed(2)} ${unit}`}
      aria-label={`Bottleneck stage: ${stage.name}, ${value.toFixed(2)} ${unitWord}`}
    >
      <span className="material-symbols-rounded" aria-hidden="true" style={{ fontSize: 12 }}>
        schedule
      </span>
      {label} <span className="num">{value.toFixed(1)}{unit}</span>
    </span>
  );
}
